import {
  type InteractiveAuthResponse,
  InteractiveAuthResponseEnum,
} from "@b2bportal/purchase-api";
import { getObjectKeysAsObject } from "@checkout/helpers";
import type { CartContext } from "@checkout/index";
import type { DoneInvokeEvent } from "xstate";

export const ENABLE_POLL_INTERACTIVE = false;

export const Guards = {
  wasPendingInteractivePaymentAuth: (
    _ctx: CartContext,
    event: DoneInvokeEvent<InteractiveAuthResponse>
  ) =>
    event.data.InteractiveAuthResponse ===
    InteractiveAuthResponseEnum.PendingInteractivePaymentAuth,
  shouldUsePollInteractive: (_ctx: CartContext) => ENABLE_POLL_INTERACTIVE,
};

export const GuardTypes = getObjectKeysAsObject(Guards);
